"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiContainedButtonStyles = exports.disableFontColor = exports.disableBGColor = exports.focusSecondaryBGColor = exports.focusBGColor = exports.focusedStateLayerColor = exports.hoverSecondaryBGColor = exports.hoverBGColor = exports.secondaryBackgroundColor = exports.defaultBackgroundColor = void 0;
var component_2023_utils_token_parser_1 = require("@rentspree/component-2023.utils.token-parser");
var combine_rgba_1 = require("../../utils/combine-rgba");
exports.defaultBackgroundColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.container.color');
exports.secondaryBackgroundColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.secondary.container.color');
var hoveredStateLayerColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.hovered.state-layer.color');
exports.hoverBGColor = (0, combine_rgba_1.combineRGBA)(exports.defaultBackgroundColor, hoveredStateLayerColor);
exports.hoverSecondaryBGColor = (0, combine_rgba_1.combineRGBA)(exports.secondaryBackgroundColor, hoveredStateLayerColor);
exports.focusedStateLayerColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.focused.state-layer.color');
exports.focusBGColor = (0, combine_rgba_1.combineRGBA)(exports.defaultBackgroundColor, exports.focusedStateLayerColor);
exports.focusSecondaryBGColor = (0, combine_rgba_1.combineRGBA)(exports.secondaryBackgroundColor, exports.focusedStateLayerColor);
exports.disableBGColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.disabled.container.color');
exports.disableFontColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.disabled.label-text.color');
exports.muiContainedButtonStyles = {
    styleOverrides: {
        contained: {
            height: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.container.height'),
            borderRadius: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.container.shape'),
            padding: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.container.padding'),
            fontFamily: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.label-text.font'),
            fontWeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.label-text.weight'),
            fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.label-text.size'),
            letterSpacing: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.label-text.letter-spacing'),
            lineHeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.label-text.line-height'),
            textAlign: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.label-text.alignment'),
            boxShadow: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.container.elevation'),
            textTransform: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.label-text.text-transform'),
            minWidth: 'initial',
            '& .MuiButton-iconSizeSmall': {
                '& > *:first-of-type': {
                    fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.small.icon.size'),
                },
            },
            '& .MuiButton-iconSizeMedium': {
                '& > *:first-of-type': {
                    fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.icon.size'),
                },
            },
            '& .MuiButton-iconSizeLarge': {
                '& > *:first-of-type': {
                    fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.large.icon.size'),
                },
            },
            '& .MuiButton-startIcon': {
                color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.icon.color'),
            },
        },
        containedSecondary: {
            backgroundColor: exports.secondaryBackgroundColor,
            ':hover': {
                backgroundColor: exports.hoverSecondaryBGColor,
                boxShadow: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.container.elevation'),
            },
            ':focus': {
                backgroundColor: exports.focusSecondaryBGColor,
                boxShadow: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.container.elevation'),
            },
        },
        containedPrimary: {
            backgroundColor: exports.defaultBackgroundColor,
            color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.label-text.color'),
            ':hover': {
                backgroundColor: exports.hoverBGColor,
                boxShadow: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.container.elevation'),
            },
            ':focus': {
                backgroundColor: exports.focusBGColor,
                boxShadow: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.container.elevation'),
            },
        },
        containedSizeLarge: {
            height: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.large.container.height'),
            padding: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.large.container.padding'),
            fontFamily: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.large.label-text.font'),
            fontWeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.large.label-text.weight'),
            fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.large.label-text.size'),
            letterSpacing: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.large.label-text.letter-spacing'),
            lineHeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.large.label-text.line-height'),
        },
        containedSizeSmall: {
            height: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.small.container.height'),
            padding: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.small.container.padding'),
            fontFamily: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.small.label-text.font'),
            fontWeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.small.label-text.weight'),
            fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.small.label-text.size'),
            letterSpacing: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.small.label-text.letter-spacing'),
            lineHeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.contained-button.small.label-text.line-height'),
        },
        root: {
            '&.Mui-disabled.MuiButton-contained': {
                backgroundColor: exports.disableBGColor,
                color: exports.disableFontColor,
                '& .MuiButton-startIcon': {
                    color: exports.disableFontColor,
                },
            },
        },
    },
};
//# sourceMappingURL=contained-button.js.map